import { render, staticRenderFns } from "./CVPreview.vue?vue&type=template&id=f2307bbc&"
import script from "./CVPreview.vue?vue&type=script&lang=js&"
export * from "./CVPreview.vue?vue&type=script&lang=js&"
import style0 from "./CVPreview.vue?vue&type=style&index=0&id=f2307bbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports